module.exports = __webpack_public_path__ + "img/laundry.40ce4aba.svg";